/**
 * Reference-mandate rules shared by the expert registration forms.
 *
 * Mirrors the server-side source of truth in `expert/registration_sync.py`
 * (`MANDATE_YEAR_MIN` / `mandate_year_max`), so the year input hints at exactly
 * the range `validate_expertise` enforces — the same arrangement as the phone
 * rule in `lib/contact.ts`. The server remains the rule: it is what refuses a
 * year that gets past the input.
 */

export const MANDATE_YEAR_MIN = 1950;

/** The latest year a mandate may claim: read now, never at module load. */
export function mandateYearMax() {
  return new Date().getFullYear();
}
